import React from 'react';
import { Mark } from '../api.ts';
import { ContractTab, PubliceringsAvtalModal } from '../ApplicationSystem';

interface KontraktTabProps {
  mark: Mark;
  user: any;
  isAdmin?: boolean;
  myPerms: { canEditMark?: boolean } | null;
  showPubAvtal: boolean;
  setShowPubAvtal: (v: boolean) => void;
  pubAvtalSigned: boolean;
  setPubAvtalSigned: (v: boolean) => void;
  pubAvtalSignName: string;
  setPubAvtalSignName: (v: string) => void;
  T: any;
}

export function KontraktTab({
  mark, user, isAdmin, myPerms,
  showPubAvtal, setShowPubAvtal,
  pubAvtalSigned, setPubAvtalSigned,
  pubAvtalSignName, setPubAvtalSignName,
  T,
}: KontraktTabProps) {
  return (
    <>
      <div style={{padding:'0 clamp(10px,3vw,28px) 60px'}}>
        {/* Publiceringsavtal — venari ↔ Markägare */}
        {(isAdmin||(myPerms?.canEditMark))&&(
          <div style={{marginBottom:32}}>
            <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4,letterSpacing:'0.04em',textTransform:'uppercase'}}>Publiceringsavtal med venari</div>
            <div style={{fontSize:12,color:T.textSub,marginBottom:14,lineHeight:1.6}}>
              Avtalet reglerar venaris rätt att publicera din jaktmark på plattformen och förmedla jakträtter till jägare. venari tar 20 % av varje transaktion och betalar ut 80 % till dig mot faktura med 30 dagars betalningstid.
            </div>
            <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:'16px 20px',display:'flex',justifyContent:'space-between',alignItems:'center',gap:16,flexWrap:'wrap' as const}}>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>{mark.name}</div>
                <div style={{display:'flex',gap:16,flexWrap:'wrap' as const}}>
                  <span style={{fontSize:11,color:T.textSub}}>📋 Publiceringsavtal</span>
                  <span style={{fontSize:11,color:T.textSub}}>Förmedlingsarvode: <strong style={{color:'#EE8F09'}}>20 %</strong></span>
                  <span style={{fontSize:11,color:T.textSub}}>Utbetalning: <strong style={{color:'#61D836'}}>80 %</strong></span>
                  <span style={{fontSize:11,color:T.textSub}}>Betalningstid: <strong>30 dagar</strong></span>
                </div>
                {pubAvtalSigned&&<div style={{marginTop:8,fontSize:11,color:'#4CAF50',fontWeight:700}}>✓ Signerat av {pubAvtalSignName}</div>}
              </div>
              <button
                onClick={()=>setShowPubAvtal(true)}
                style={{padding:'9px 20px',background:'#EE8F09',border:'none',borderRadius:6,color:'#fff',cursor:'pointer',fontWeight:700,fontSize:13,whiteSpace:'nowrap' as const}}
              >
                {pubAvtalSigned?'Visa avtal':'Granska & signera avtal'}
              </button>
            </div>
          </div>
        )}
        {/* Separationslinje */}
        <div style={{borderTop:`1px solid ${T.border}`,marginBottom:24}}/>
        <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:16,letterSpacing:'0.04em',textTransform:'uppercase'}}>Jakträttskontrakt med jägare</div>
        <ContractTab markId={mark.id} isAdmin={!!isAdmin}/>
      </div>
      {/* Publiceringsavtal modal */}
      {showPubAvtal&&(
        <PubliceringsAvtalModal
          markName={mark.name}
          ownerName={user?.name||(user?.given_name&&user?.family_name?`${user.given_name} ${user.family_name}`:undefined)||user?.email}
          ownerEmail={user?.email}
          areaHa={mark.areaHa}
          onClose={()=>setShowPubAvtal(false)}
          onSigned={(name)=>{setPubAvtalSigned(true);setPubAvtalSignName(name);setShowPubAvtal(false);}}
        />
      )}
    </>
  );
}
